<template>
    <div>
        <div class="login-form-session">
            <p class="subtitle">
                Доступ заблокирован
            </p>

            <template v-if="pinStatus">
                <p class="subtitle">
                    Вы ввели неверный пин-код 5 раз. Пройдите заново авторизацию
                </p>

                <a-button
                    type="primary"
                    class="login-btn"
                    @click="onSubmit"
                >
                    Войти заново
                </a-button>
            </template>
            <template v-else>
                <p class="subtitle">
                    Вы ввели неверный логин или пароль 3 раза. Пожалуйста,
                    обратитесь к администратору
                </p>

                <a-button
                    type="primary"
                    class="login-btn"
                    @click="onSubmit"
                >
                    Выйти
                </a-button>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SessionNoAccess',
    emits: ['button-ok'],
    data() {
        return {
            pinStatus: false,
        };
    },
    mounted() {
        this.$nextTick(() => {
            if ('parametrs' in localStorage && Object.keys(localStorage.parametrs).length) {
                const {
                    pinGlobalSetup,
                    pinSetup,
                } = JSON.parse(localStorage.parametrs);

                if (pinGlobalSetup && pinSetup) {
                    this.pinStatus = true;
                }
            }
        });
    },
    methods: {
        onSubmit() {
            this.$emit('button-ok');
        },
    },
};
</script>

<style scoped lang="scss">
.login-form-session {
    display: flex;
    flex-direction: column;
    align-items: center;

    .ant-form-item {
        margin-bottom: 18px;
    }
    .ant-form-explain {
        margin-bottom: -17px;
        text-align: left;
        font-size: 13px;
    }

    h1 {
        font-size: 26px;
        font-weight: bold;
        margin-bottom: 8px;
        text-align: center;
    }

    .subtitle {
        color: #666;
        font-size: 14px;
        margin-bottom: 20px;
        text-align: center;
    }

    .pin-inputs {
        display: flex;
        justify-content: center;
        gap: 8px;
        margin-bottom: 20px;

        .pin-digit {
            width: 50px;
            height: 50px;
            text-align: center;
            font-size: 20px;
            border-radius: 8px;
            border: 1px solid #d9d9d9;

            &:focus {
                border-color: #83b274;
                box-shadow: 0 0 0 2px rgb(131, 178, 116, 0.2);
            }
        }
    }

    .error-message {
        color: #ff4d4f;
        font-size: 12px;
        margin-bottom: 15px;
        text-align: left;
        max-width: 100%;
        word-break: break-word; // Перенос длинных слов
        white-space: pre-wrap; // Сохраняет переносы строк
        line-height: 1.4;
        padding: 8px 10px;
        background: #fff5f5;
        border: 1px solid #ffccc7;
        border-radius: 4px;
        overflow-x: hidden;
    }

    .login-btn {
        min-width: 110px;
        height: auto;
        font-size: 14px;
        margin-bottom: 18px;
        max-width: fit-content;
        padding: 7px 20px;
        background-color: #8dc07c;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 0px 4px rgba(46, 75, 37, 0.4);
        border: none;
        color: #fff;

        &:disabled,
        &[disabled] {
            pointer-events: none;
            opacity: 0.5;
        }

        &:hover {
            background-color: #74b85d;
        }
    }

    .forgot-pin {
        text-align: center;

        a {
            text-decoration: none;
            color: #83b274;
            font-size: 14px;
            transition: color 0.3s;

            &:hover {
                color: #74b85d;
            }
        }
    }

    img {
        display: block;
        margin: 0 auto 4px;
        max-width: 100px;
    }

    .app-title {
        display: block;
        color: #00706c;
        font-weight: 600;
        font-size: 14px;
        font-family: Arial, sans-serif !important;
        margin-bottom: 7px;
        text-align: center;
    }
}

/* Кастомизация модального окна */
.custom-modal .ant-modal-content {
    border-radius: 12px;
    padding: 20px;
    text-align: center;
}

.custom-modal .ant-modal-header {
    background-color: #f9f9f9;
    border-bottom: none;
    padding: 20px 24px;
    border-radius: 12px 12px 0 0;
}

.custom-modal .ant-modal-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    line-height: 1.4;
    text-align: center;
}

.custom-modal .ant-modal-body {
    padding: 20px 24px;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    text-align: center;
}

.custom-modal .ant-modal-footer {
    border-top: none;
    padding: 16px 24px;
    display: flex;
    justify-content: center;
}

/* Кнопка "Войти заново" */
.custom-ok-button {
    width: 100%;
    height: 40px;
    font-size: 16px;
    border-radius: 8px;
    background-color: #1890ff !important; // Ярко-синий как на скрине
    border: none !important;
    color: white !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #40a9ff !important;
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
    }
}
</style>
